import React from "react"
import PropTypes from "prop-types"
import SubServiceCard from "shared/components/service_card.js"
import { serviceShape } from "app/lib/shared_prop_types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

class ServiceCard extends React.Component {
  handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: "story",
      object_id: this.props.service.module_name,
      object_type: "service",
      position: this.props.position,
      field_position: this.props.fieldPosition,
      service_numeric_id: this.props.service.id,
    })
  }

  render() {
    return (
      <li
        className="service-card-list-item"
        ref={el => {
          this.scrollObserverEl = el
        }}
      >
        <SubServiceCard
          service={this.props.service}
          onClick={this.handleOnClick}
          path={`/${this.props.service.module_name}`}
        />
      </li>
    )
  }
}

ServiceCard.propTypes = {
  service: serviceShape.isRequired,
  position: PropTypes.number.isRequired,
  fieldPosition: PropTypes.number,
}

export default ServiceCard
